import Image from 'next/image';
import Link from 'next/link';

export default function CTASection() {
  return (
    <>
      {/* Feature section with brand panel */}
      <div className="relative">
        <div className="absolute inset-0 flex flex-col" aria-hidden="true">
          <div className="flex-1 bg-white" />
          {/* <div className="flex-1" /> */}
        </div>
        <div className="relative mx-auto max-w-7xl px-6 lg:px-8">
          <div className="overflow-hidden rounded-lg bg-gradient-to-r from-orange-400 to-teal-400 shadow-xl lg:grid lg:grid-cols-2 lg:gap-4">
            <div className="px-6 pt-10 pb-12 sm:px-16 sm:pt-16 lg:py-16 lg:pr-0 xl:py-20 xl:px-20">
              <div className="lg:self-center">
                <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
                  <span className="block">Zaczynamy?</span>
                  <span className="block text-red-900">
                    Odkryj benefity skatalogowanego księgozbioru.
                  </span>
                </h2>
                <p className="mt-4 text-lg leading-6 text-orange-50">
                  Kup pakiet podstawowy i przetestuj rozwiązanie na własnej biblioteczce.
                </p>
                <Link
                  href="/kody"
                  className="shadow mt-8 inline-flex items-center rounded-md border border-transparent bg-orange-100 py-3 px-6 text-base font-medium text-red-600 hover:text-red-500"
                >
                  Pakiet Podstawowy
                </Link>
              </div>
            </div>
            <div className="aspect-w-5 aspect-h-3 -mt-6 md:aspect-w-2 md:aspect-h-1">
              <Image
                className="translate-x-6 translate-y-6 transform rounded-md object-cover object-left-top sm:translate-x-16 lg:translate-y-20"
                src={require('@/assets/images/dashboard.webp')}
                alt="Dashboard Bibliodesku"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
